import { render, staticRenderFns } from "./type4.vue?vue&type=template&id=7cd0357c&scoped=true"
import script from "./type4.vue?vue&type=script&lang=js"
export * from "./type4.vue?vue&type=script&lang=js"
import style0 from "./type4.vue?vue&type=style&index=0&id=7cd0357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd0357c",
  null
  
)

export default component.exports